import {ProfileCardView} from "./profile-card.view";
import {Person, Profile} from "@betrue/shared/interfaces";

interface ProfileCardProps {
  profile: Profile
  person: Person
}

export const ProfileCard = (props: ProfileCardProps) => {

  return (
    <span>
     <ProfileCardView profile={props.profile} person={props.person}/>
    </span>
  );
}

